<template>
    <div>
        <div class="w3-animate-opacity">
            <!-- Itens Selecioandos -->
            <div class="row">
                <div class="col" :class="item_formula(value) ? 'col-12 col-md-8' : ''">
                    <template>
                        <az-input
                            sizing="sm"
                            v-model="value.item.search"
                            :edicao="value.item.incluir">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend" v-if="!habilita_ordem">
                                    <button type="button" class="btn btn-outline-danger" @click="excluirItem(value)">
                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                            <template v-slot:button-pos v-if="!habilita_ordem">
                                <div class="input-group-append" v-if="!habilita_ordem">
                                    <span class="input-group-text" id="basic-addon2" title="Id de Medicamento">
                                        <small>#{{ value.id_medicamento }}</small>
                                    </span>
                                </div>

                                <input type="number" placeholder="1" class="form-control" v-if="name== 'requisicao'"
                                    style="max-width: 50px; margin: auto;" v-model="value.in_quantidade">
                                <div class="input-group-append">
                                    <!-- Botão de Execução Imediata -->
                                    <button type="button" class="btn btn-sm btn-outline-success" v-if="value.fl_execucao_imediata === true || value.fl_execucao_imediata === false"
                                        data-toggle="tooltip" data-placement="top" title="Execução Imediata"
                                        @click="value.fl_execucao_imediata = !value.fl_execucao_imediata">
                                        <i class="fa fa-play" aria-hidden="true" v-if="value.fl_execucao_imediata == false"></i>
                                        <i class="fa fa-pause" aria-hidden="true" v-if="value.fl_execucao_imediata == true"></i>
                                    </button>

                                    <!-- Botão de Edição da Descrição -->
                                    <button type="button" class="btn btn-sm btn-outline-primary"
                                        v-if="value.item && value.item.fl_permite_editar_texto && value.item.st_texto_requisicao"
                                        data-toggle="tooltip" data-placement="top" title="Editar Texto"
                                        @click="value.st_texto_impressao = value.item.st_texto_requisicao; value.fl_texto_editado = !value.fl_texto_editado">
                                        <i class="fas fa-pen"></i>
                                    </button>

                                    <!-- Botão de Lançamento Ordenado -->
                                    <button type="button" class="btn btn-sm btn-outline-success" v-if="name == 'receita'"
                                        data-toggle="tooltip" data-placement="top" title="Incluir antes"
                                        @click="incluir_antes(index)">
                                        <template v-if="inclusao">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </template>
                                        <template v-else>
                                            <i class="fa fa-plus mr-1" aria-hidden="true"></i>
                                            <i class="fas fa-arrow-up"></i>
                                        </template>
                                    </button>

                                    <button class="btn btn-sm btn-outline-primary" type="button"
                                        data-toggle="tooltip" data-placement="top" title="Observações"
                                        @click="value.st_observacoes = ( value.st_observacoes !== null ? null : '' )">
                                        <i class="fas fa-comment"></i>
                                    </button>

                                    <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button"
                                        title="Agrupamento na impressão" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                        v-if="!item_formula(value) || value.fl_imprimir_separado">
                                        <span v-if="!value.fl_imprimir_separado && value.item && value.item.grupo && value.item.grupo.st_sigla">
                                            {{ value.item.grupo.st_sigla }}
                                        </span>
                                        <i class="fas fa-copy fa-fw mr-2" v-else-if="value.fl_imprimir_separado"></i>
                                        <i class="fas fa-file fa-fw mr-2" v-else></i>
                                    </button>

                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="value.fl_imprimir_separado = false">
                                            <i class="fas fa-file mr-2"></i>Imprimir Junto
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="value.fl_imprimir_separado = true">
                                            <i class="fas fa-copy mr-2"></i>Imprimir Separado
                                        </a>
                                        <template v-if="procGrupos && procGrupos.length">
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item" href="#" @click.prevent="selecionar_grupo(value, grupo)"
                                                v-for="(grupo, igx) in procGrupos" :key="igx">
                                                {{ grupo.st_sigla }}
                                            </a>
                                        </template>

                                        <template v-if="value && value.item && !value.item.incluir">
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item" href="#" @click.prevent="incluir_proc(value)">
                                            <i class="fa fa-plus mr-2" aria-hidden="true"></i>Editar e Incluir
                                            </a>
                                        </template>
                                    </div>
                                </div>
                            </template>
                        </az-input>

                        <az-input
                            type="textarea"
                            rows="3"
                            v-if="value.fl_texto_editado"
                            v-model="value.st_texto_impressao" />

                    </template>
                </div>

                <div class="col col-12 col-md-2" v-if="item_formula(value)">
                    <az-input
                        sizing="sm"
                        placeholder="Qtd..."
                        type="number"
                        v-model="value.in_quantidade" />
                </div>

                <div class="col col-12 col-md-2" v-if="item_formula(value)">
                    <az-input
                        sizing="sm"
                        type="select"
                        optionsMode="aql"
                        service="apresentacoes.index"
                        v-model="value.apresentacao" />
                </div>
            </div>

            <!-- Complementos de Receita -->

            <div class="form-row" :class="value.st_observacoes !== null ? 'mb-0' : 'mb-2'" v-if="name == 'receita' && !item_formula(value) && !habilita_ordem">
                <div class="col col-12 col-md-2">
                    <az-input
                        sizing="sm"
                        placeholder="Qtd..."
                        type="number"
                        v-model="value.in_quantidade" />

                    <div class="input-group input-group-sm mb-0" v-if="value && value.item && value.item.fl_diluente">
                        <input type="text" class="form-control" placeholder="Diluente" disabled>
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary" type="button" id="button-addon2" title="Adicionar medicamento diluído." @click="incluir_antes(index + 1, index)">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>

                    <div v-else-if="value.diluido" class="small text-muted">
                        Diluído
                    </div>
                </div>

                <div class="col col-12 col-md-3">
                    <az-input
                        sizing="sm"
                        type="select"
                        optionsMode="aql"
                        service="apresentacoes.index"
                        v-model="value.apresentacao" />

                    <div v-if="value.dc_dose_calc || value.fl_calc_edit">
                        <az-input
                            type="number"
                            sizing="sm"
                            placeholder="Dose..."
                            :edicao="!!value.fl_calc_edit"
                            v-model="value.dc_dose_calc">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button type="button" class="btn btn-outline-primary" v-if="!value.fl_calc_edit" @click="value.fl_calc_edit = true"><i class="fa-solid fa-pen-to-square"></i></button>
                                    <button type="button" class="btn btn-outline-secondary" v-else @click="value.fl_calc_edit = false"><i class="fa-solid fa-xmark"></i></button>
                                </div>
                            </template>
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">{{ value.apresentacao.st_unid_calc }}</span>
                                </div>
                            </template>
                        </az-input>
                    </div>

                    <div v-if="edicao.fl_ciclos && edicao.st_tipo != 'U' && edicao.st_tipo_receita != 'U'" class="small text-muted">
                        <az-input
                            sizing="sm"
                            placeholder="Não informado..."
                            :validate="validate"
                            v-model="value.st_ciclo_dias">
                            <template v-slot:button-pre>
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">Dias</span>
                            </div>
                            </template>
                        </az-input>
                    </div>
                </div>

                <div class="col col-12 col-md-7">
                    <az-input
                        type="textarea"
                        :rows="edicao.fl_ciclos ? 3 : 2"
                        sizing="sm"
                        placeholder="Posologia..."
                        maxlength="1000"
                        v-model="value.st_posologia"
                        :edicao="!edicao.kit || !edicao.kit.fl_block_posologia" />
                </div>
            </div>

            <div class="row" v-if="value.fl_cirurgia">
                <div class="col">
                    <az-input
                    sizing="sm"
                    placeholder="Código da Cirurgia..."
                    :required="cod_cirurg_obrig"
                    :validate="validate"
                    v-model="value.st_codigo"
                    />
                </div>
            </div>

            <!-- Complementos de Requisição -->

            <div class="row mb-2" v-if="value.st_observacoes !== null ">
                <div class="col">
                    <az-input
                    sizing="sm"
                    placeholder="Observações..."
                    type="textarea"
                    :rows="calc_rows(value.st_observacoes)"
                    maxlength="1000"
                    v-model="value.st_observacoes" />
                </div>
            </div>
        </div>        
    </div>
</template>

<script>
import AzInput from "../../shared/forms/AzInput.vue";

export default {
    components: { 
        AzInput,
    },

    props: [
        'value', 'habilita_ordem', 'name', 'inclusao', 'procGrupos', 'cod_cirurg_obrig', 'validate', 'edicao',
    ],

    methods: { 
        excluirItem(item) {
            item.fl_ativo = false;
        }, 

        item_formula (item) {
            return item.apresentacao && item.apresentacao.id_apresentacao == 49;
        },

        calc_rows (texto) { 
            if ( !texto )
            return 1;

            let tem_linhas = /\r|\n/.exec(texto);

            if ( texto.length > 100 || tem_linhas ) { 
            return 4;
            }

            return 1;
        },
    }
}
</script>